import React from "react";

const PlusRoundedIcon = React.forwardRef(
  (
    {
      size = 34,
      variant = "solid", 
      rx = 8,
      bgColor = "#7583F0",
      frameColor = "#7583F0",
      plusColor = "#FFFFFF",
      strokeWidth = 1,
      className,
      ...props
    },
    ref
  ) => {
    const computedPlusFill = variant === "solid" ? plusColor : frameColor;

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {variant === "solid" ? (
          <rect width="34" height="34" rx={rx} fill={bgColor} />
        ) : (
          <rect
            x="0.5"
            y="0.5"
            width="33"
            height="33"
            rx={rx}
            stroke={frameColor}
            strokeWidth={strokeWidth}
            fill="none"
          />
        )}

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 8.75C17.3797 8.75 17.6875 9.0578 17.6875 9.4375V16.3125H24.5625C24.9422 16.3125 25.25 16.6203 25.25 17C25.25 17.3797 24.9422 17.6875 24.5625 17.6875H17.6875V24.5625C17.6875 24.9422 17.3797 25.25 17 25.25C16.6203 25.25 16.3125 24.9422 16.3125 24.5625V17.6875H9.4375C9.0578 17.6875 8.75 17.3797 8.75 17C8.75 16.6203 9.0578 16.3125 9.4375 16.3125H16.3125V9.4375C16.3125 9.0578 16.6203 8.75 17 8.75Z"
          fill={computedPlusFill}
        />
      </svg>
    );
  }
);

export default React.memo(PlusRoundedIcon);
